import React from 'react';
import { Button, Table, Col, Form, Icon, Input, message, Modal, Row, Tooltip } from 'antd';
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { patchEventGuests, } from "../../services/evt";
import GuestLibrarySelect from "../GuestLibrary/GuestLibrarySelect";


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewGuesLibrarys extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false,

            selectedRowKeys: [],
            selectedRows: [],
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }


    resetFormFields = () => {
        this.props.form.resetFields();
    }
    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
    }


    save = () => {
        let { selectedRows } = this.state;
        if (selectedRows.length == 0) {
            message.error('请先选择嘉宾');
            return;
        }
        let values = JSON.parse(JSON.stringify(selectedRows).replace(/id/g, "groupId"));
        let _values = {
            eventId: this.props.evt.header.id,
            __self__: this.props.evt.guests.concat(values),
        }
        this.changeFormLoading(true);

        _values.__self__.forEach((obj, index) => {
            obj.seq = index;
        })
        patchEventGuests(_values).then(res => {
            if (res.code == 200) {
                message.info("添加成功!");
                this.props.editableChange(this.props.editableStatePropName, false, true)
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
            this.changeFormLoading(false)
        })
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }



    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    render() {
        const evt = this.props.evt;
    

        return (

            <Modal
                visible={this.props.editable}
                title="添加嘉宾"
                width="880px"
                maskClosable={false}
                afterClose={() => this.resetFormFields()}
                onCancel={this.handleCancel}
                footer={[
                    <Button key="back" onClick={this.handleCancel}>
                        放弃
                        </Button>,
                    <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                        添加
                        </Button>,
                ]}
            >
                <div>
                    <GuestLibrarySelect
                        onChangeSelect={(rowKeys,rows)=>{
                            this.onSelectChange(rowKeys,rows)
                        }}
                    />
                </div>

            </Modal>

        )
    }
}


EvtViewGuesLibrarys.contextTypes = {}

EvtViewGuesLibrarys.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "addGuestEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewGuesLibrarys.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewGuesLibrarys));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewGuesLibrarys.jsx